<template>
  <div class="search-modal">
    <div
      id="info"
      class="image"
    >
      <SightImage
        :src="sight.experience_main_photo_url"
        :alt="sight.name"
        width="100%"
        height="100%"
        aspect-ratio="4 / 3"
      />
    </div>
    <ModalNav
      class="navbar"
      :modal-nav="modalNav"
      :nav-is-loading="navIsLoading"
      :analytics-base="analyticsBase"
    />
    <div class="sight-content">
      <SightInfo
        v-if="modalNav.info"
        :sight="sight"
        :analytics-base="analyticsBase"
      />
      <SightPosition
        v-if="modalNav.position"
        :sight="sight"
        :city="city"
        :analytics-base="analyticsBase"
      />
      <GuidesReview
        v-if="modalNav.guides"
        :sight="sight"
        :comments="guideComments"
        :guide-data="guideShare"
        :has-more="hasMoreGuideComments"
        :is-loading="navIsLoading"
        :analytics-base="analyticsBase"
        @show-more="emit('show-more-guide-comments')"
      />
      <div
        v-if="modalNav.experience && $slots.experience"
        id="experience"
        class="experience-section obs-el"
        data-attr="experience"
      >
        <slot name="experience" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import GuidesReview from '@/features/sights/GuidesReview.vue';
  import ModalNav from '@/features/sights/ModalNav.vue';
  import SightInfo from '@/features/sights/SightInfo.vue';
  import SightPosition from '@/features/sights/SightPosition.vue';
  import type { SightGuideComment, SightModalCity, SightModalNav, SightModalSight } from '@/shared/types/sight-modal';
  import SightImage from '@/shared/ui/sights/SightImage.vue';

  withDefaults(
    defineProps<{
      sight: SightModalSight;
      city: SightModalCity;
      modalNav: SightModalNav;
      navIsLoading?: boolean;
      guideComments?: SightGuideComment[];
      guideShare?: SightGuideComment | null;
      hasMoreGuideComments?: boolean;
      analyticsBase?: Record<string, unknown>;
    }>(),
    {
      navIsLoading: false,
      guideComments: () => [],
      guideShare: null,
      hasMoreGuideComments: false,
      analyticsBase: () => ({}),
    },
  );

  const emit = defineEmits<{
    'show-more-guide-comments': [];
  }>();
</script>

<style lang="scss" scoped>
  .search-modal {
    position: relative;
  }

  .navbar {
    position: sticky;
    top: 64px;
    z-index: 9;

    @include mobile {
      top: 60px;
    }
  }

  .sight-content {
    padding: 0 var(--alias-space-16);
  }

  .image {
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 4/3;
    background-image: url('@/shared/assets/images/empty.jpg');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .experience-section {
    margin-top: var(--alias-space-48);
  }
</style>
